import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

const PageBodyPrivacyPolicy = ({ body }) => {
  const { t } = useTranslation();
  const { ref: inViewRef, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  if (!Array.isArray(body)) {
    return (
      <div className="container mt-10">
        <div className="row">
          <div className="col-12">
            <p className="text-muted">{t('global.noContent', 'No content available.')}</p>
          </div>
        </div>
      </div>
    );
  }

  const renderText = (children) =>
    children
      .map((child) => (typeof child?.text === 'string' ? child.text : ''))
      .join(' ')
      .trim();

  const renderBlock = (block, index) => {
    if (!block || !Array.isArray(block.children)) return null;

    const text = renderText(block.children);
    if (!text && block.type !== 'list') return null;

    switch (block.type) {
      case 'paragraph':
        return (
          <div className="col-12 mb-0 mt-1" key={index}>
            <p className="lead mb-0 mt-0">{text}</p>
          </div>
        );

      case 'heading': {
        const HeadingTag = `h${block.level || 2}`;
        return (
          <div className="col-12 mb-0" key={index}>
            <HeadingTag className="text-black">{text}</HeadingTag>
          </div>
        );
      }

      case 'list': {
        const ListTag = block.format === 'unordered' ? 'ul' : 'ol';
        return (
          <div className="col-12 mb-0 mt-0" key={index}>
            <ListTag className="mt-0">
              {block.children.map((item, i) => {
                const itemText = renderText(item.children || []);
                return itemText ? <li key={i} className="lead">{itemText}</li> : null;
              })}
            </ListTag>
          </div>
        );
      }

      default:
        return null;
    }
  };

  return (
    <section onContextMenu={(e) => e.preventDefault()}>
      <div className="container mt-10">
        <div className="row g-3 g-xl-5" ref={inViewRef}>
          {body.map(renderBlock)}
        </div>
      </div>
    </section>
  );
};

export default PageBodyPrivacyPolicy;
